// extracted by mini-css-extract-plugin
module.exports = {"text_input":"TextInput_text_input__1DaYW"};